<template>
  <div id="custom-report-view">
    <b-button
      class="mt-3 ml-3"
      :to="`/${brand}/${$route.params.type}/reports/menu/forplan`"
      pill
      :variant="customPrimaryVariant"
    >
      <i class="mr-2 fas fa-chevron-left"></i>
      {{ $t("GoBack") }}
    </b-button>
    <div id="custom-report">
      <h1 class="my-4 text-center" v-html="$t('CustomReport')"></h1>
      <p class="text-center" v-html="$t('CustomReportText')"></p>
      <b-form ref="form" @submit.prevent="handleCustomReportForm()">
        <b-container fluid>
          <b-row align-v="center" class="mb-5 my-1">
            <b-col cols="auto">
              <label class="custom-label my-0 mx-0">
                <i class="far fa-calendar-alt"></i>
                {{ $t("PeriodOfTime") }} :
              </label>
            </b-col>
            <b-col cols="auto">
              <ul class="dates-row">
                <li>
                  <span>{{ $t("Week") }}</span>
                  <b-form-input
                    v-model="filters.end_week"
                    type="number"
                    min="0"
                    number
                    :max="filters.start_week - 1"
                  ></b-form-input>
                </li>
                <li>
                  <span>{{ $t("ToWeek") }}</span>
                  <b-form-input
                    v-model="filters.start_week"
                    type="number"
                    number
                    :min="filters.end_week + 1"
                    :max="53"
                  ></b-form-input>
                </li>
                <li>
                  <span>Année</span>
                  <b-form-input
                    v-model="filters.year"
                    type="number"
                    number
                    min="2019"
                    max="2050"
                  ></b-form-input>
                </li>
              </ul>
            </b-col>
          </b-row>
          <b-row align-v="center" class="mb-5 my-1">
            <b-col cols="auto">
              <label class="custom-label my-0 mx-0">
                <i class="fas fa-sort"></i>
                {{ $t("SortingChoice") }} :
              </label>
            </b-col>
            <b-col cols="auto">
              <b-form-radio-group
                :checked="filters.sorting_choice"
                label="Individual radios"
              >
                <b-form-radio
                  v-model="filters.sorting_choice"
                  name="sorting-choice"
                  value="point"
                  >Tri par point de vente</b-form-radio
                >
                <b-form-radio
                  v-model="filters.sorting_choice"
                  name="sorting-choice"
                  value="pre_event"
                  >Tri par section</b-form-radio
                >
                <b-form-radio
                  v-model="filters.sorting_choice"
                  name="sorting-choice"
                  value="trade"
                  >Tri par métier</b-form-radio
                >
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row align-v="center" class="mb-3 my-1">
            <b-col cols="auto">
              <label class="custom-label my-0 mx-0">
                <i class="fas fa-ad"></i>
                {{ $t("Medias") }} :
              </label>
            </b-col>
            <b-col cols="auto">
              <b-form-checkbox
                v-model="allMedias"
                @change="toggleAllMedias"
                id="select-all-medias"
                >{{ $t("SelectAllMediasLabel") }}</b-form-checkbox
              >
            </b-col>
          </b-row>

          <ul
            class="medias-list"
            v-for="(cat, keyIndex) in filters.cat"
            :key="keyIndex"
          >
            <p>
              <b-form-checkbox @change="toggleAllMediasWithCat($event, cat)"
                ><b>{{ cat }}</b></b-form-checkbox
              >
            </p>
            <div v-for="(media, key) in filters.medias" :key="key">
              <li v-if="cat === media.type" class="mb-5">
                <b-form-checkbox
                  @change="resetAllMedias"
                  v-model="media.active"
                  :id="key"
                >
                  <span class="mx-1 icon" :class="media.icon"></span>
                  {{ media.name }}
                </b-form-checkbox>
              </li>
            </div>
          </ul>

          <b-row align-v="center" class="mb-4 my-1">
            <b-col cols="auto">
              <label class="custom-label my-0 mx-0">
                <i class="fas fa-tasks"></i>
                {{ $t("Operations") }} :
              </label>
            </b-col>
            <b-col cols="auto">
              <b-form-checkbox
                v-model="filters.operation"
                id="select-all-operation"
                >{{ $t("IncludeOperation") }}</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row align-v="center" class="mb-4 my-1">
            <b-col cols="auto">
              <label class="custom-label my-0 mx-0">
                <i class="fas fa-map-marker-alt"></i>
                {{ $t("NamePOS") }} :
              </label>
            </b-col>
            <b-col cols="auto">
              <b-form-checkbox
                v-model="allPos"
                @change="toggleAllPos"
                id="select-all-pos"
                >{{ $t("SelectAllPosLabel") }}</b-form-checkbox
              >
            </b-col>
          </b-row>
          <v-select
            :closeOnSelect="false"
            :placeholder="$t('SearchByPos')"
            v-if="!allPos"
            :reduce="(item) => item.point_code"
            label="name"
            multiple
            v-model="filters.pos"
            :options="pos"
          />
          <p
            v-if="filters.pos.length > 0"
            v-html="$t('SelectedPos', { count: filters.pos.length })"
          ></p>
          <b-row>
            <b-col class="text-center mt-2 mb-2" cols="12">
              <b-form-radio-group :checked="filters.type_file">
                <b-form-radio
                  v-model="filters.type_file"
                  name="sorting-choice"
                  value="xlsx"
                  ><i large class="fas fa-file-excel fa-lg mr-1 green"> </i
                  >{{ $t("FormatExcel") }}
                </b-form-radio>
                <b-form-radio
                  v-model="filters.type_file"
                  name="sorting-choice"
                  value="pdf"
                >
                  <i class="fas fa-file-pdf fa-lg mr-1 red"></i
                  >{{ $t("FormatPDF") }}</b-form-radio
                >
              </b-form-radio-group>
            </b-col>
          </b-row>
        </b-container>

        <div class="text-center my-3">
          <b-button pill :variant="customPrimaryVariant" type="submit">
            <i v-if="!isLoading" class="mr-2 fas fa-chart-bar"></i>
            <i v-else class="mr-2 fas fa-spinner fa-spin"></i>
            {{ $t("CreateReportButton") }}
          </b-button>
          <p class="mt-2" v-if="error">{{ $t("CustomReportFormNotValid") }}</p>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { fr } from "vuejs-datepicker/dist/locale";
import http from "@/helpers/http";
import Vue from "vue";
import { mapGetters } from "vuex";
import common from "../../helpers/common";

export default {
  name: "CustomReport",
  watch: {
    "filters.start_week": function () {
      this.filters.range = this.filters.start_week - this.filters.end_week;
    },
    "filters.end_week": function () {
      this.filters.range = this.filters.start_week - this.filters.end_week;
    },
  },
  beforeMount() {
    common.isAuth(this, http);
  },
  data() {
    return {
      error: false,
      fr: fr,
      selected: null,
      medias: [],
      pos: [],
      allMedias: false,
      allPos: false,
      filters: {
        type_file: "pdf",
        operation: true,
        start_week: 52, // count backward --
        end_week: 1,
        year: 2020,
        range: 52,
        sorting_choice: "point",
        medias: {},
        pos: [],
        cat: [],
        title: "Rapport d'activité personnalisé",
        abundance: this.$cookie.get("allowRate") == "true",
      },
    };
  },
  mounted() {
    this.getMediaSupport();
    this.getPosList();
  },
  computed: {
    ...mapGetters(["isLoading"]),
    brand() {
      return this.$route.params.brand;
    },
    customPrimaryVariant() {
      return this.brand + "-customPrimary";
    },
  },
  methods: {
    toggleAllMediasWithCat(event, cat) {
      Object.keys(this.filters.medias).forEach((key) => {
        if (this.filters.medias[key].type === cat) {
          Vue.set(this.filters.medias[key], "active", event);
        }
      });
    },
    resetAllMedias() {
      this.allMedias = false;
    },
    toggleAllMedias(checked) {
      Object.keys(this.filters.medias).forEach((key) => {
        Vue.set(this.filters.medias[key], "active", checked);
      });
    },
    toggleAllPos(checked) {
      if (checked) this.filters.pos = [];
    },
    setupMediaFilters(medias) {
      let type = "";

      medias.forEach((media) => {
        switch (media.type) {
          case "offline":
            type = this.$i18n.t("offline");
            break;
          case "online":
            type = this.$i18n.t("online");
            break;
          case "marketing":
            type = this.$i18n.t("marketing2");
            break;
          case "other":
            type = this.$i18n.t("other");
            break;
        }

        if (!this.filters.cat.includes(type)) {
          this.filters.cat.push(type);
        }

        Vue.set(this.filters.medias, media.media_support_code, {
          name: media.name,
          icon: media.icon,
          active: false,
          type: type,
        });
      });
    },
    setupPos() {
      this.pos.forEach((item) => {
        item.name = item.pointofinterest.details.name;
      });
    },
    async getPosList() {
      try {
        let res = await http.get(
          this.$store.state.apiUrl + "/global/posDetails",
          this.$cookie.get("auth"),
          this.$cookie.get("authExpires")
        );
        if (res[0]) {
          this.pos = res[0].data;
        }
        this.setupPos();
      } catch (err) {
        console.log(err);
      }
    },
    async getMediaSupport() {
      try {
        let res = await http.get(
          this.$store.state.apiUrl + "/global/media_support",
          this.$cookie.get("auth"),
          this.$cookie.get("authExpires")
        );

        if (res[0]) {
          this.medias = res[0].data;
          this.setupMediaFilters(this.medias);
        }
      } catch (err) {
        console.log(err);
      }
    },
    validateMedias() {
      let firstMediaChecked = Object.values(this.filters.medias).find(
        (media) => {
          return media.active;
        }
      );
      return firstMediaChecked !== undefined || this.allMedias;
    },
    validatePos() {
      return this.filters.pos.length > 0 || this.allPos;
    },
    validateForm() {
      return (
        this.filters.start_week != null &&
        this.filters.end_week != null &&
        this.filters.sorting_choice &&
        (this.validateMedias() || this.filters.operation === true) &&
        this.validatePos()
      );
    },
    async handleCustomReportForm() {
      let self = this;
      this.$store.commit("SET_LOADING", true);
      this.error = false;
      if (this.validateForm()) {
        try {
          let res = await http.postPDF(
            this.$store.state.apiUrl + "/global/generateCustomReportPreplan",
            this.filters,
            this.$cookie.get("auth"),
            this.$cookie.get("authExpires")
          );
          if (res[0] == undefined) {
            common.makeToast(
              self,
              self.$i18n.t("Error"),
              self.$i18n.t("noDataReport"),
              self.$route.params.brand + "-customDanger",
              "b-toaster-bottom-center",
              true
            );
          }
          if (res[0]) {
            this.forceFileDownload(res[0].data, this.filters.type_file);
          }
          this.$store.commit("SET_LOADING", false);
        } catch (err) {
          console.log(err);
          this.$store.commit("SET_LOADING", false);
        }
      } else {
        this.$store.commit("SET_LOADING", false);
        this.error = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/custom-vars.scss";

#custom-report {
  margin: auto;
  width: 900px;
  max-width: 95%;

  .custom-label {
    font-weight: bold;
    font-size: 18px;

    i {
      margin-right: 6px;
    }
  }
}

.dates-row {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin: 0;
  padding: 0;
  list-style: none;

  > li {
    margin: 0 10px;
    display: flex;
    align-items: center;

    > span {
      margin-right: 10px;
    }
  }
}

.medias-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 0;
  padding: 0;
  list-style: none;
  margin-left: 30px;
  margin-bottom: 2rem;

  > li {
    margin-bottom: 15px;
    font-weight: bold;

    .icon {
    }
  }
}

.vs__search::placeholder {
  opacity: 0.6;
}

@media screen and (max-width: 700px) {
  .medias-list {
    grid-template-columns: repeat(2, 1fr);
  }

  .dates-row {
    flex-direction: column;

    > li {
      margin-bottom: 10px;
    }
  }
}
</style>
